import { useCallback, useEffect, useRef } from 'react';

type callbackType = () => Promise<any> | any;

export const useThrottleExecution = () => {
  const timeoutRef = useRef<NodeJS.Timeout | undefined>(undefined);

  const clear = () => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = undefined;
  };

  const throttledExecution = useCallback(
    async ({ callback, delay = 500, signal }: { callback: callbackType; delay?: number; signal?: AbortSignal }) => {
      if (timeoutRef.current) return;

      await callback();
      clear();

      timeoutRef.current = setTimeout(async () => {
        clear();
      }, delay);

      signal?.addEventListener('abort', () => {
        clear();
      });

      return clear;
    },
    []
  );

  useEffect(() => {
    clear();
  }, []);

  return throttledExecution;
};
